export const gaTrack = (data: any) => {
  if (typeof window === 'undefined') {
    return ''
  }
  ;(window as any).dataLayer = (window as any).dataLayer || []
  try {
    ;(window as any).dataLayer?.push({ event_parameters: null })
    ;(window as any).dataLayer?.push(data || {})
  } catch (error) {
    console.log('pageGTMEvent error', error)
  }
}
